export default __webpack_public_path__ + "static/media/alert.72d5668f.wav";